<one-select
  #select
  [config]="config"
  [keys]="KEYS"
  [dataSource]="source"
  [label]="label"
  [multiple]="multiple"
  [disabled]="isDisabled"
  [showEditIcon]="showEditIcon"
  (selectionChanged)="onSelectionChanged($event)"
  (editOption)="editOption.emit($event)"
></one-select>
